import * as fs from 'file-saver';
import {Workbook} from 'exceljs/dist/exceljs.min.js';

export class ExcelUtil {

    /**
     * Exports xlsx file with the name of file name.
     * Creates xml export using list of headers settings and list of rows data.
     * Headers list length has to be the same as every row in rows list.
     *
     * @param headerData - header data
     * @param rowsData - rows data
     * @param fileName - file name
     */
    static generateExcel(headerData: any[], rowsData: [][], fileName) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('token');

        const headerRow = worksheet.addRow(headerData);
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: 'FFF6F7F8'},
                bgColor: {argb: 'FFF6F7F8'}
            };
            cell.border = {
                top: {style: 'thin'},
                left: {style: 'thin'},
                bottom: {style: 'thin'},
                right: {style: 'thin'}
            };
        });

        rowsData.forEach(row => {
            worksheet.addRow(row);
        });

        worksheet.getColumn(1).width = 60;
        worksheet.getColumn(2).width = 50;
        worksheet.getColumn(3).width = 50;

        workbook.xlsx.writeBuffer().then((excelData) => {
            const blob = new Blob([excelData], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            fs.saveAs(blob, fileName);
        });
    }
}
